import { EnvelopeClosedIcon, EnvelopeOpenIcon } from "@radix-ui/react-icons";
import { Tooltip, TooltipContent, TooltipTrigger } from "components/Tooltip";

/**
 * A conversation's read state as a mail icon: a closed envelope with a dot
 * is unread, an open envelope is read. Clicking it (or Enter or Space)
 * switches it, for the signed-in admin only.
 */
export default function ReadToggle({
  unread,
  onToggle,
}: {
  unread: boolean;
  onToggle: () => void;
}) {
  const label = unread ? "Mark as read" : "Mark as unread";
  return (
    <Tooltip>
      <TooltipTrigger>
        <button
          type="button"
          onClick={onToggle}
          aria-label={label}
          className="relative mx-auto flex h-8 w-8 items-center justify-center rounded-full hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2b77cf]"
        >
          {unread ? (
            <>
              <EnvelopeClosedIcon
                width="18"
                height="18"
                className="text-gray-800"
                aria-hidden
              />
              <span
                aria-hidden
                className="absolute right-1 top-1 h-2.5 w-2.5 rounded-full bg-blue-500 ring-2 ring-white"
              />
            </>
          ) : (
            <EnvelopeOpenIcon
              width="18"
              height="18"
              className="text-gray-400"
              aria-hidden
            />
          )}
        </button>
      </TooltipTrigger>
      <TooltipContent>
        <span className="text-xs">{label}</span>
      </TooltipContent>
    </Tooltip>
  );
}
